module.exports = __webpack_public_path__ + "static/media/supported_hardware.52e266af.webp";